/**
 * Prøvens officielle emneområder — ordret grundlag fra bekendtgørelsen om godskørsel.
 *
 * REGLER FOR DENNE FIL:
 *  1. Indholdet er myndighedsfastsat. Ret kun her, hvis bekendtgørelsen ændres —
 *     og kontrollér altid mod kilden i SOURCE nedenfor.
 *  2. Dette er IKKE Votras egen dagsplan. Det er de emner, Færdselsstyrelsen kræver
 *     at kurset dækker, og som prøven stiller spørgsmål inden for.
 *  3. Bilag 1 = transportleder i virksomhed med tilladelse efter godskørselslovens
 *     § 1, stk. 1 og 3 (lastbil/vogntog over 3.500 kg) — mindst 144 lektioner.
 *     Bilag 2 = tilladelse efter § 1, stk. 2 (varebil) — mindst 37 lektioner.
 *     En lektion = 60 minutter inkl. op til 15 minutters pause.
 */

export const SOURCE = {
  label: "Bekendtgørelse om godskørsel (Retsinformation)",
  url: "https://www.retsinformation.dk/eli/lta/2018/1222",
};

export const EXAM_PROVIDER_SOURCE = {
  label: "Færdselsstyrelsens liste over godkendte prøveudbydere for godsvognmænd",
  url: "https://www.fstyr.dk/privat/chauffoeruddannelser/uddannelser-i-godskoersel/proever-for-godsvognmaend",
};

export const SYLLABI = {
  bilag1: {
    key: "bilag1",
    name: "Bilag 1 til bekendtgørelsen om godskørsel",
    scope: "Transportleder i virksomhed med tilladelse til godskørsel med lastbil eller vogntog over 3.500 kg",
    lessons: 144,
    lessonNote: "Mindst 144 lektioner à 60 minutter inkl. op til 15 minutters pause.",
    areas: [
      {
        letter: "A",
        title: "Borgerlig ret",
        points: [
          "De vigtigste transportkontrakter inden for vejtransport og de rettigheder og forpligtelser, der følger af dem.",
          "At forhandle en transportkontrakt, så den bliver retsgyldig, bl.a. med hensyn til transportbetingelserne.",
          "At bedømme en klage fra ordregiveren over skader (tab, beskadigelse, forsinkelse) og vurdere konsekvenserne for det kontraktuelle ansvar.",
          "Regler og forpligtelser i CMR-konventionen om fragtaftaler ved international vejgodstransport.",
        ],
      },
      {
        letter: "B",
        title: "Handelsret",
        points: [
          "Betingelser og formkrav for at drive handelsvirksomhed, generelle forpligtelser (registrering, forretningsbøger) og konsekvenser af konkurs.",
          "De forskellige selskabsformer samt reglerne for at oprette og drive dem.",
        ],
      },
      {
        letter: "C",
        title: "Arbejdsmarkeds- og sociallovgivning",
        points: [
          "Vejtransportsektorens arbejdsmarkedsinstitutioner: fagforeninger, samarbejdsudvalg, personalerepræsentanter og arbejdsinspektører.",
          "Arbejdsgiverens forpligtelser vedrørende social sikring.",
          "Reglerne for arbejdskontrakter for de forskellige medarbejderkategorier, kontraktformer, arbejdsvilkår, arbejdstid, ferie med løn, aflønning og opsigelse.",
          "Køre-, hvile- og arbejdstidsbestemmelserne, især forordning (EU) nr. 165/2014, forordning (EF) nr. 561/2006 samt direktiv 2002/15/EF og 2006/22/EF, og hvordan de gennemføres i praksis.",
          "Reglerne om grundlæggende kvalifikationer og efteruddannelse for erhvervschauffører, især direktiv 2003/59/EF.",
        ],
      },
      {
        letter: "D",
        title: "Skattelovgivning",
        points: [
          "Moms på transportydelser.",
          "Vægtafgifter.",
          "Afgifter på køretøjer til vejgodstransport samt brugsafgifter på visse infrastrukturanlæg.",
          "Indkomstskat.",
        ],
      },
      {
        letter: "E",
        title: "Forretningsmæssig og økonomisk virksomhedsledelse",
        points: [
          "Betalingsmidler: check, veksler, egenveksler og kreditkort, regler og praktisk anvendelse.",
          "Låneformer (banklån, remburs, kautionering, leasing) og de byrder og forpligtelser, de indebærer.",
          "At forstå, opbygge og fortolke en status (balance).",
          "At læse og fortolke en resultatopgørelse.",
          "At analysere virksomhedens finansielle situation og rentabilitet ud fra finansielle nøgletal.",
          "At lægge et budget.",
          "Virksomhedens kostpris: faste og variable omkostninger, driftsmidler og afskrivninger, og beregning pr. køretøj, pr. km, pr. tur og pr. ton.",
          "At udarbejde virksomhedens organisation skematisk og tilrettelægge arbejdsplaner.",
          "Marketing, reklame og PR for transportydelser, salgsfremstød og kundekartoteker.",
          "Forsikringsformer i vejtransport: ansvarsforsikring, personskade- og livsforsikring, tingsskade- og rejsegodsforsikring samt garantier og forpligtelser.",
          "Elektronisk datatransmission i vejtransport.",
          "Fakturering af godskørselsydelser og betydningen af Incoterms.",
          "Støtteerhvervene i transport, deres betydning, opgaver og retlige stilling.",
        ],
      },
      {
        letter: "F",
        title: "Adgang til markedet",
        points: [
          "De faglige regler for vejtransport for fremmed regning, leje af erhvervskøretøjer, underentreprise, adgang til erhvervet, tilladelser samt kontrol og sanktioner.",
          "Bestemmelserne om at oprette en vejtransportvirksomhed.",
          "De dokumenter, der kræves til vejtransportydelser, og kontrolmetoder for dokumenter i virksomheden og i køretøjerne.",
          "Reglerne for organisering af markedet for godskørsel, speditionsfirmaer og logistik.",
          "Formaliteter ved grænsepassage, T-dokumenter og TIR-carnets samt de forpligtelser og det ansvar, der følger med.",
        ],
      },
      {
        letter: "G",
        title: "Tekniske standarder og tekniske aspekter af driften",
        points: [
          "Reglerne for køretøjers vægt og dimensioner samt procedurerne for særtransporter.",
          "At vælge de rigtige køretøjer og bestanddele (chassis, motor, bremser) efter virksomhedens behov.",
          "Formaliteter ved godkendelse, indregistrering og syn af køretøjer.",
          "At vurdere foranstaltninger mod støj- og luftforurening.",
          "At udarbejde periodiske vedligeholdelsesplaner for køretøjer og udstyr.",
          "Håndterings- og læssegrej samt metoder og instrukser for lastning og losning: lastfordeling, stabling og fastgørelse.",
          "Teknikker for kombineret transport (huckepack, roll-on/roll-off).",
          "Procedurer for transport af farligt gods og affald (direktiv 2008/68/EF og forordning (EF) nr. 1013/2006).",
          "Procedurer for transport af letfordærvelige levnedsmidler (ATP-traktaten).",
          "Procedurer for transport af levende dyr.",
        ],
      },
      {
        letter: "H",
        title: "Vejtrafiksikkerhed",
        points: [
          "Kvalifikationskrav til det kørende personale: kørekort, sundhedsattester og duelighedsbeviser.",
          "At sikre, at færdselsregler, forbud og trafikbegrænsninger i de forskellige medlemsstater overholdes, hastighed, forkørselsret, standsning, parkering, lygteføring og vejskiltning.",
          "At udarbejde instrukser til chaufførerne om kontrol af sikkerhedsbestemmelser for materiel, udstyr og ladning samt om forebyggende adfærd.",
          "At indføre regler for håndtering af ulykkestilfælde og forebyggelse af gentagne ulykker eller grove færdselsovertrædelser.",
          "Procedurer og teknikker for sikkerhedsmæssigt forsvarlig fastgørelse af gods.",
        ],
      },
      {
        letter: "I",
        title: "Chaufførvikarvirksomhed",
        points: [
          "Drift af chaufførvikarvirksomhed: tilladelseskrav, markedsadgang og arbejdsgiveransvar.",
          "Ansættelsesretslig lovgivning og arbejdsmiljølovgivning.",
          "Arbejdsskadeforsikring, sygdom, retshjælp og overenskomstforhold for bus- og godschauffører.",
        ],
      },
      {
        letter: "J",
        title: "Forhandlingsteknik",
        points: [
          "Forskellen mellem forhandling og salg/køb, og hvordan man opnår en vinder/vinder-situation.",
          "At forberede, planlægge og gennemføre forhandlingens faser.",
          "Strategi, taktik og de psykologiske faktorer i forhandlingsspillet.",
          "Den gode forhandler, og identifikation af modpartens motiver og mål.",
          "Økonomiske overvejelser og vurdering af konsekvenserne.",
        ],
      },
      {
        letter: "K",
        title: "Trafiksikkerhedsledelse",
        points: [
          "At udarbejde målsætninger og en trafiksikkerhedspolitik.",
          "At udarbejde registreringssystemer, der belyser uheldsfrekvens, -art og -årsag.",
          "At udarbejde planer for medarbejderinddragelse og information om virksomhedens trafiksikkerhedspolitik.",
          "At indføre systemer til måling af brændstofforbrug.",
          "Chaufførhåndbogens indhold, og hvordan den vedligeholdes og håndhæves.",
          "Certificeringsordninger om trafiksikkerhed.",
        ],
      },
    ],
  },

  bilag2: {
    key: "bilag2",
    name: "Bilag 2 til bekendtgørelsen om godskørsel",
    scope: "Tilladelse til godskørsel for fremmed regning med varebil (2.500-3.500 kg tilladt totalvægt)",
    lessons: 37,
    lessonNote: "Mindst 37 lektioner à 60 minutter inkl. op til 15 minutters pause.",
    areas: [
      {
        letter: "A",
        title: "Transportkontrakter",
        points: [
          "Aftaleloven og købeloven samt de vigtigste transportkontrakter inden for vejtransport og de rettigheder og forpligtelser, der følger af dem.",
          "At forhandle en transportkontrakt, så den bliver retsgyldig, bl.a. med hensyn til transportbetingelserne.",
          "At bedømme en klage fra ordregiveren over skader (tab, beskadigelse, forsinkelse) og vurdere konsekvenserne for det kontraktuelle ansvar.",
          "Regler og forpligtelser i CMR-konventionen om fragtaftaler ved international vejgodstransport.",
        ],
      },
      {
        letter: "B",
        title: "Handelsret",
        points: [
          "Betingelser og formkrav for at drive handelsvirksomhed, generelle forpligtelser (registrering, forretningsbøger) og konsekvenser af konkurs.",
          "De forskellige selskabsformer samt reglerne for at oprette og drive dem.",
        ],
      },
      {
        letter: "C",
        title: "Arbejdsmarkedsforhold",
        points: [
          "Vejtransportsektorens arbejdsmarkedsinstitutioner: fagforeninger, samarbejdsudvalg, personalerepræsentanter og arbejdsinspektører.",
          "Arbejdsgiverens forpligtelser vedrørende social sikring.",
          "Reglerne for arbejdskontrakter for de forskellige medarbejderkategorier, herunder chaufførvikarer, kontraktformer, arbejdsvilkår, arbejdstid, ferie med løn, aflønning og opsigelse.",
        ],
      },
      {
        letter: "D",
        title: "Skattelovgivning",
        points: [
          "Moms på transportydelser.",
          "Brændstofforbrugsafgifter.",
          "Afgifter på køretøjer til vejgodstransport.",
          "Indkomstskat.",
        ],
      },
      {
        letter: "E",
        title: "Forretningsmæssig og økonomisk virksomhedsledelse",
        points: [
          "Almindelige økonomiske begreber og beregningsværktøjer: faste og variable omkostninger, totalomkostninger, marginalomkostninger, cost-benefit-analyse, optimering og fakturering.",
          "At vurdere og vælge mellem forskellige finansieringsformer.",
          "Den generelle økonomiske kontekst, virksomhedens værdikæde og transportkæden.",
        ],
      },
      {
        letter: "F",
        title: "Forsikring",
        points: [
          "Lovpligtige og frivillige forsikringer og deres dækningsområder, ansvarsforsikring, personskade- og livsforsikring, tingsskade- og rejsegodsforsikring samt garantier og forpligtelser.",
        ],
      },
      {
        letter: "G",
        title: "Adgang til markedet og generelle vilkår",
        points: [
          "De faglige regler for vejtransport for fremmed regning, leje af erhvervskøretøjer, underentreprise, adgang til erhvervet, tilladelser samt kontrol og sanktioner.",
          "Bestemmelserne om at oprette en vejtransportvirksomhed.",
          "De dokumenter, der kræves til vejtransportydelser, og kontrolmetoder for dokumenter i virksomheden og i køretøjerne.",
          "Reglerne for organisering af markedet for godskørsel, speditionsfirmaer og logistik.",
          "Formaliteter ved grænsepassage, T-dokumenter og TIR-carnets samt de forpligtelser og det ansvar, der følger med.",
          "Køre-, hvile- og arbejdstidsbestemmelserne, især forordning (EU) nr. 165/2014, forordning (EF) nr. 561/2006 samt direktiv 2002/15/EF og 2006/22/EF.",
          "Reglerne om grundlæggende kvalifikationer og efteruddannelse for førere af varebiler (kapitel 8a i bekendtgørelsen om kvalifikationskrav).",
        ],
      },
      {
        letter: "H",
        title: "Lastsikring og læssegrej",
        points: [
          "Håndterings- og læssegrej (bagsmække, paller m.m.) samt metoder og instrukser for læsning og aflæsning: lastfordeling, stabling og fastgørelse.",
          "Arbejdstilsynets regler om værnemidler og løftemateriel, herunder syn af lifte og værnemidler.",
        ],
      },
      {
        letter: "I",
        title: "Transport af særligt gods",
        points: [
          "Fødevarelovgivningen og ATP-konventionen om letfordærvelige fødevarer, og procedurer for at overholde reglerne.",
          "Reglerne for transport af farligt gods og affald (ADR).",
        ],
      },
      {
        letter: "J",
        title: "Trafiksikkerhedsledelse",
        points: [
          "Målsætninger og trafiksikkerhedspolitik.",
          "Registreringssystemer, der belyser uheldsfrekvens, -art og -årsag.",
          "Planer for medarbejderinddragelse og information om trafiksikkerhedspolitikken.",
          "Systemer til måling af brændstofforbrug.",
          "Chaufførhåndbøger.",
          "Certificeringsordninger om trafiksikkerhed.",
        ],
      },
    ],
  },

  bilag3: {
    key: "bilag3",
    name: "Bilag 3 til taxibekendtgørelsen",
    scope: "Kvalifikationsuddannelsen for taxi-, limousine- og flexchauffører m.fl.",
    lessons: 74,
    lessonNote:
      "Kurset skal vare mindst 74 timer, heraf mindst 6 individuelle køretimer. En time er 60 minutter inklusive op til 15 minutters pause. Uddannelsen afsluttes med både en teoretisk og en praktisk prøve.",
    areas: [
      {
        letter: "1",
        title: "Arbejdsret",
        points: [
          "Generelle arbejdsretslige regler, tillidsrepræsentant, samarbejdsudvalg, ansættelse og afskedigelse, graviditet, orlov, foreningsforhold og ligestilling på arbejdsmarkedet.",
        ],
      },
      {
        letter: "2",
        title: "Færdselslovgivning",
        points: [
          "Bilens indretning og udstyr, køretøjers manøvreegenskaber og trafikantadfærd.",
          "Manøvrer på vej og særlige risikoforhold i trafikken, med vægt på de emner, der kan relateres til arbejdet som fører af bil til erhvervsmæssig persontransport.",
        ],
      },
      {
        letter: "3",
        title: "Energirigtig og passagervenlig kørsel, brug af GPS (individuelle køretimer)",
        points: [
          "At køre rutineret, passagervenligt og defensivt, så farlige situationer observeres i tid, og både skadesrisiko og brændstofforbrug begrænses.",
          "Sammenhængen mellem køremåde og de faktiske driftsomkostninger, brændstof og vedligehold.",
          "At betjene GPS eller tilsvarende positioneringssystem samt køretøjets øvrige hjælpeudstyr.",
        ],
      },
      {
        letter: "4",
        title: "Taxilovgivningen",
        points: [
          "De gældende regler i taxilovgivningen: betingelser for tilladelser, taxametre og kontrolapparater, kørselskontorer, regler for betaling og særlige krav til bilen.",
        ],
      },
      {
        letter: "5",
        title: "Arbejdsmiljø, herunder ergonomi",
        points: [
          "Sikkerhedsorganisation, arbejdsgiverens og den ansattes pligter, arbejdspladsvurdering (APV) samt regler for hvileperioder og fridøgn.",
          "Løfteteknik og ergonomi ved chaufførens typiske opgaver, håndtering af ældre og handicappede samt bagage. Omsorg for egen krop og psyke, ernæring, beklædning og hjælpemidler.",
        ],
      },
      {
        letter: "6",
        title: "Befordring af særlige grupper",
        points: [
          "Særlige gruppers behov og de enkelte grupper af personer, chaufføren møder.",
          "At afstemme den fysiske og psykiske kontakt til passageren ud fra dennes aktuelle handicap.",
          "Teknikker og hjælpemidler til personforflytning, kørestolsteknik, trappemaskine, gangredskaber og ganghjælpemidler, samt kommunikation med handicappede og patienter.",
        ],
      },
      {
        letter: "7",
        title: "Konflikthåndtering og kommunikation",
        points: [
          "Verbal og non-verbal kommunikation og viden om forskellige konflikttyper.",
          "Adfærd der op- eller nedtrapper konflikter, og teorier som konflikttrappen og konfliktpyramiden brugt som konkrete redskaber.",
        ],
      },
      {
        letter: "8",
        title: "Kundeservice",
        points: [
          "At yde kundevenlig service og kørsel og tilpasse sin optræden, så den højner virksomhedens image.",
          "Chaufførens roller, vedligeholdelse af køretøjet, tilrettelæggelse af arbejdet samt kommercielle og finansielle følger af tvister.",
        ],
      },
      {
        letter: "9",
        title: "Førstehjælp (11 timer)",
        points: [
          "Dansk Førstehjælpsråds uddannelser \"Færdselsrelateret førstehjælp\" og \"Førstehjælp ved hjertestop\".",
          "Har du gennemført begge kurser inden for de seneste 12 måneder, kan du fritages for undervisning i førstehjælp.",
        ],
      },
    ],
    source: {
      label: "Taxibekendtgørelsen, bilag 3 (BEK nr. 1244 af 26/11/2019)",
      url: "https://www.retsinformation.dk/eli/lta/2019/1244",
    },
  },
};

/** De øvrige krav Færdselsstyrelsen stiller, FØR tilladelsen kan udstedes. */
export const PERMIT_REQUIREMENTS = [
  {
    title: "Etablering",
    text: "Virksomheden skal have en driftscentral, hvorfra hovedaktiviteterne administreres, og hvor tilladelsen og kernedokumenterne opbevares. Virksomheden skal opfylde de skatteretlige krav, være momsregistreret når det kræves, og råde over køretøjer og chauffører i et omfang, der svarer til transportaktiviteterne.",
  },
  {
    title: "Økonomi (kapitalkrav)",
    text: "Virksomheden skal dokumentere egne kontante midler eller andre værdier svarende til antallet af tilladelser, der ansøges om. Kravet skal være opfyldt i hele tilladelsens gyldighedsperiode og kan dokumenteres med åbningsbalance, seneste reviderede årsrapport, revisorerklæring eller garanti fra bank eller forsikringsselskab.",
  },
  {
    title: "Transportleder",
    text: "Virksomheden skal udpege en godkendt transportleder, der faktisk og vedvarende forestår ledelsen af godskørslen og har reel tilknytning til virksomheden. Transportlederen skal have bestået vognmandsprøven og opfylde vandelskravet. En ekstern konsulent kan være transportleder for op til fire virksomheder med højst 50 køretøjer i alt.",
  },
  {
    title: "Løn- og arbejdsvilkår",
    text: "Virksomhedens samlede omkostningsniveau for chaufførerne må ikke afvige væsentligt og entydigt fra de retningsgivende kollektive overenskomster. Der er ikke krav om medlemskab af en arbejdsgiverforening.",
  },
  {
    title: "Vandel",
    text: "Virksomheden, den administrerende direktør og transportlederen må ikke være dømt for forhold, der kan begrunde fare for nye overtrædelser i vejtransporterhvervet. Tidligere konkurser i gods- eller buskørselsvirksomheder kan også indgå i vurderingen.",
  },
];

export const PERMIT_FACTS = {
  feePerPermit: 1500,
  feePerCopy: 1500,
  validityYears: 10,
  decisionTargetDays: 60,
  source: {
    label: "Fællesskabstilladelsen (Færdselsstyrelsen)",
    url: "https://www.fstyr.dk/erhverv/gods/faellesskabstilladelsen",
  },
};

export const getSyllabus = (key) => SYLLABI[key] || null;
